import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';

import orderList from '@/views/orders/OrderList.vue';
import orderDetail from '@/views/orders/OrderDetail.vue';
import orderCreate from '@/views/orders/OrderCreate.vue';

import assetList from '@/views/assets/AssetList.vue';
import assetDetail from '@/views/assets/AssetDetail.vue';

import reportList from '@/views/reports/ReportList.vue';

import myProfile from '@/views/users/MyProfile.vue';
import editMyProfile from '@/views/users/EditMyProfile.vue';

import timecard from '@/views/timecard/Timecard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/orders',
    name: 'work-orders',
    component: orderList
  },
  {
    path: '/orders/create',
    name: 'create-order',
    component: orderCreate
  },
  {
    path: '/orders/:id',
    name: 'work-order-detail',
    component: orderDetail
  },
  {
    path: '/assets',
    name: 'assets',
    component: assetList
  },
  {
    path: '/assets/:id',
    name: 'asset-detail',
    component: assetDetail
  },
  {
    path: '/profile',
    name: 'my-profile',
    component: myProfile
  },
  {
    path: '/profile/:id',
    name: 'edit-my-profile',
    component: editMyProfile
  },
  {
    path: '/reports',
    name: 'reports',
    component: reportList
  },
  {
    path: '/timecard',
    name: 'timecard',
    component: timecard
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
